<template>
  <div class="mt-2 mb-5 mx-5 mt-sm-5 mb-sm-15 mx-sm-10">
    <v-row no-gutters>
      <v-col
        cols="12"
        md="2"
        class="text-start"
        style="display: flex; align-items: center"
      >
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("user.registration.registrations") }}
        </span>
      </v-col>

      <v-col cols="12" md="10">
        <v-row justify-md="end">
          <template v-if="havePermissionCreateTrainingRegistration">
            <v-col cols="12" sm="6" md="auto">
              <v-btn
                depressed
                :block="!$vuetify.breakpoint.mdAndUp"
                height="45"
                color="primary"
                style="text-transform: unset"
                class="rounded-lg font-weight-normal my-2"
                @click="reRoute(1)"
              >
                <vue-feather type="user-plus" size="14" class="me-1" />
                {{ $t("course.registration") }}
              </v-btn>
            </v-col>
          </template>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <RegistrationsFilters @filter="filterBy" :loading="loading" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <registration-list
          :datas="registrationsData"
          :loading="loading"
          @reFetch="refetch"
        />
      </v-col>
      <v-col cols="12" v-if="registrationsData && registrationsData.length">
        <!-- <div class="d-flex justify-end textLight--text subtitle-2">
          <p
            class="ma-0"
            style="cursor: pointer"
            v-if="variables.skip"
            @click="onClickPrev"
          >
            Prev
          </p>
          <p
            class="ma-0 ms-5"
            style="cursor: pointer"
            v-if="
              totalCount > variables.skip + variables.limit &&
              totalCount > variables.limit
            "
            @click="onClickNext"
          >
            Next
          </p>
        </div> -->

        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RegistrationList from "../components/RegistrationsList.vue";
import RegistrationsFilters from "../components/RegistrationsFilters.vue";
import ReportsFilters from "../../reports-module/components/ReportsFilters.vue";
import Pagination from "../../core-module/components/Pagination.vue";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    RegistrationList,
    RegistrationsFilters,
    // ReportsFilters,
    Pagination,
  },
  data() {
    return {
      registrationsData: [],
      loading: true,
      variables: {
        limit: 10,
        skip: 0,
      },
      filterInputs: {},
      totalCount: null,
      totalPages: 0,
      debounceSearch: null,
    };
  },
  computed: {
    havePermissionCreateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },

  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: this.variablesDefaultValue(),
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.registrationsData =
              data.getTrainingRegistrations.trainingRegistrations;
            this.totalCount = data.getTrainingRegistrations.totalCount;

            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }

          this.loading = loading;
        },
      };
    },
  },
  created() {
    this.$apollo.queries.getTrainingRegistrations.refetch();
  },
  methods: {
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },

    reRoute(val) {
      this.$router.push({
        name: "Registration",
        params: { data: val },
      });
    },
    // onClickNext() {
    //   this.variables.skip = this.variables.limit + this.variables.skip;
    //   this.refetch();
    // },
    // onClickPrev() {
    //   this.variables.skip = this.variables.skip - this.variables.limit;
    //   this.refetch();
    // },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    filterBy(key, value) {
      if (key === "search") {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(value);
        }, 500);
        return;
      }

      const newFilters = { ...this.filterInputs };
      if (!value) {
        delete newFilters[key];
      } else {
        newFilters[key] = value;
      }
      this.filterInputs = newFilters;
      
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
    apiSearch(val) {
      const searchText = val?.trim() ?? "";
      const newFilters = { ...this.filterInputs };

      if (searchText.length > 0) {
        newFilters.search = searchText;
      } else {
        delete newFilters.search;
      }

      this.filterInputs = newFilters;
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
    async refetch() {
      this.loading = true;
      // Create a shallow copy to ensure Apollo detects the variable change
      const currentFilters = { ...this.filterInputs };
      
      this.$apollo.queries.getTrainingRegistrations.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: Object.keys(currentFilters).length > 0 ? currentFilters : null,
      });
    },
  },
};
</script>
